import { Trans } from '@/components'

export function SelectMachineWarning() {
  return (
    <div className="t-sm text-warning mt-2">
      <Trans i18nKey="create.selectMachineWarning">*Please select an instance first</Trans>
    </div>
  )
}
